import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import Home from './pages/Home';
import Services from './pages/Services';
import Products from './pages/Products';
import RnD from './pages/RnD';
import Certifications from './pages/Certifications';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Checkout from './pages/Checkout';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import Blog from './pages/Blog';
import Article from './pages/Article';
import Admin from './pages/Admin';
import Competition from './pages/Competition';
import PrivateLabel from './pages/PrivateLabel';
import ContractManufacturing from './pages/ContractManufacturing';
import InfluencerBrand from './pages/InfluencerBrand';
import OemSkincare from './pages/OemSkincare';
import DopamineLaunch from './pages/DopamineLaunch';
import Analytics from './components/Analytics';
import CompetitionBar from './components/CompetitionBar';

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  return (
    <>
      <Analytics />
      {!isAdmin && <CompetitionBar />}
      {!isAdmin && <Navbar />}
      {!isAdmin && <CartDrawer />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <LanguageProvider>
          <CartProvider>
            <BrowserRouter>
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/shop/:id" element={<ProductDetail />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/payment/success" element={<PaymentSuccess />} />
                  <Route path="/payment/cancel" element={<PaymentCancel />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<Article />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/rnd" element={<RnD />} />
                  <Route path="/certifications" element={<Certifications />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/competition" element={<Competition />} />
                  <Route path="/private-label-cosmetics" element={<PrivateLabel />} />
                  <Route path="/contract-cosmetics-manufacturing" element={<ContractManufacturing />} />
                  <Route path="/influencer-beauty-brand" element={<InfluencerBrand />} />
                  <Route path="/oem-skincare-manufacturer" element={<OemSkincare />} />
                  <Route path="/dopamine" element={<DopamineLaunch />} />
                  <Route path="/admin" element={<Admin />} />
                </Routes>
              </Layout>
            </BrowserRouter>
          </CartProvider>
        </LanguageProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
